import { useContext } from "react";

import useTranslation from "next-translate/useTranslation";
import PropTypes from "prop-types";

import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";
import Carousel from "shared/components/organisms/Carousel";
import GlobalContext from "shared/providers/context/GlobalContext";

import removeDisabledContent from "../util/removeDisabledContent";

const Blog = ({ contents }) => {
  const { t } = useTranslation();

  const { state } = useContext(GlobalContext);
  const tenantSettings = state?.tenancy?.settings;
  const blogAreaTitle = tenantSettings.blog?.blogAreaTitle;

  return (
    <>
      {contents?.length > 0 && (
        <ComponentErrorBoundary>
          <Carousel
            zIndex={26}
            context="blog"
            sectionLink="/blog"
            sectionTitle={blogAreaTitle || "Blog"}
            items={removeDisabledContent(contents)}
            sectionDescription={t("common:seeAllPost")}
          />
        </ComponentErrorBoundary>
      )}
    </>
  );
};

Blog.defaultProps = {
  contents: {},
};

Blog.propTypes = {
  contents: PropTypes.object,
};

export default Blog;
